const zhTW = {
  // ── Navbar ──────────────────────────────────────
  nav_solutions: '系統開發',
  nav_infrastructure: '網絡基礎設施',
  nav_security: '網絡安全',
  nav_cases: '成功案例',
  nav_about: '關於我們',
  nav_contact_cta: '立即報價',
  nav_whatsapp: 'WhatsApp',

  // ── Hero ─────────────────────────────────────────
  hero_badge: '企業級 IT 解決方案供應商',
  hero_title1: '企業級安全防護',
  hero_title2: '與智慧 IT 系統',
  hero_highlight1: '企業防火牆部署',
  hero_highlight2: '網絡基礎設施設計',
  hero_highlight3: '客製化系統開發',
  hero_focus: '專注於',
  hero_desc: '我們為中小企業及大型機構提供全方位 IT 服務——涵蓋系統開發、網絡基礎設施到網絡安全防護，全面保障您的數位資產。',
  hero_cta1: '免費安全評估',
  hero_cta2: '查看成功案例',
  stat_clients: '企業客戶',
  stat_uptime: '系統正常運行率',
  stat_support: '24/7 全天候支援',

  // ── Services ─────────────────────────────────────
  services_badge: '核心服務',
  services_title: '全方位企業 IT 解決方案',
  services_desc: '從系統開發到網絡安全，我們提供一站式 IT 服務，助您的業務在數位時代保持競爭優勢',
  svc1_title: '系統開發',
  svc1_desc: '為企業量身打造 ERP、雲端應用及移動解決方案，提升運營效率，推動數位轉型。',
  svc1_f1: 'ERP / CRM 系統',
  svc1_f2: '雲端 SaaS 應用',
  svc1_f3: 'API 整合',
  svc1_f4: '移動應用程式',
  svc2_title: '網絡基礎設施',
  svc2_desc: '設計高效、可擴展的企業網絡，優化跨辦公室及國際連接，解決延遲及頻寬瓶頸。',
  svc2_f1: 'SD-WAN 解決方案',
  svc2_f2: 'LAN / WAN 優化',
  svc2_f3: '無線網絡覆蓋',
  svc2_f4: '網絡監控',
  svc3_title: '網絡安全',
  svc3_desc: '部署新一代防火牆 (NGFW)、WAF 及入侵偵測系統，主動防禦駭客、勒索軟件及 DDoS 威脅。',
  svc3_f1: 'NGFW 防火牆部署',
  svc3_f2: 'WAF 網頁防護',
  svc3_f3: 'DDoS 防護',
  svc3_f4: '滲透測試',
  learn_more: '了解更多',

  // ── Features / Why Choose Us ──────────────────────
  features_badge: '為何選擇我們',
  features_title1: '卓越技術實力',
  features_title2: '您信賴的 IT 合作夥伴',
  features_desc: '我們不只是服務供應商——更是您長期的 IT 轉型夥伴，從方案設計到部署，全程提供技術支援。',
  feat_r1_title: '資深技術團隊',
  feat_r1_desc: '核心成員持有 Cisco、Fortinet、Palo Alto 國際認證，擁有逾 15 年企業 IT 實戰經驗。',
  feat_r2_title: '24/7 技術支援',
  feat_r2_desc: '緊急響應服務，平均故障響應時間少於 30 分鐘，確保業務不間斷運行。',
  feat_r3_title: '主動安全防禦',
  feat_r3_desc: '不等威脅來臨——透過定期安全評估與監控，主動識別並消除潛在風險。',
  feat_r4_title: '深厚行業知識',
  feat_r4_desc: '服務零售、金融、製造、醫療等行業，深入理解各行業合規要求及技術痛點。',
  cert_title: '技術認證與資質',
  cert_desc: '團隊持有多項國際認可 IT 認證，確保服務達到業界最高標準',
  cert_completed: '完成項目',
  cert_satisfaction: '客戶滿意度',
  cert_incidents: '安全事故',

  // ── Case Studies (home preview) ──────────────────
  cases_badge: '成功案例',
  cases_title: '為企業解決真實 IT 挑戰',
  cases_sub: '逾 200 個跨行業成功項目',
  cases_view_all: '查看全部案例',
  case1_tag: '零售業',
  case1_title: '大型連鎖零售商 IT 基礎設施升級',
  case1_desc: '重新設計覆蓋 50+ 門店的 SD-WAN 網絡，集中管理 POS 系統，大幅降低網絡故障率。',
  case1_m1: '網絡正常運行率',
  case1_m2: '營運成本節省',
  case2_tag: '金融業',
  case2_title: '金融公司新一代防火牆部署',
  case2_desc: '為持牌金融公司部署 Fortinet NGFW 及 WAF，達到國際合規要求，成功抵禦多次針對性攻擊。',
  case2_m1: '合規達標',
  case2_m2: '安全事故',
  case3_tag: '製造業',
  case3_title: '工廠客製化 ERP 系統開發',
  case3_desc: '為全球製造商開發整合生產排程、庫存管理及財務報告的 ERP 系統。',
  case3_m1: '生產效率提升',
  case3_m2: '投資回報期',

  // ── CTA ──────────────────────────────────────────
  cta_badge: '免費企業安全評估',
  cta_title1: '了解您的企業',
  cta_title2: 'IT 安全風險狀況',
  cta_desc: '我們的技術顧問將提供免費 IT 基礎設施評估，識別漏洞並提出改善建議——全程無隱藏收費。',
  cta_btn: '預約免費評估',
  cta_note1: '免費諮詢，無需承諾',
  cta_note2: '24 小時內回覆',
  cta_note3: '保密協議保障',

  // ── Footer ───────────────────────────────────────
  footer_desc: '全球企業 IT 服務供應商，專注於系統開發、網絡基礎設施及網絡安全，保護您在全球的數位資產。',
  footer_services_heading: '服務',
  footer_company_heading: '公司',
  footer_hours_title: '辦公時間',
  footer_hours_weekday: '週一至週五  9:00–18:00',
  footer_hours_emergency: '緊急支援全年 24/7',
  footer_copyright: '© 2026 A&B System Company, LTD. 版權所有。',
  footer_security: 'SSL 加密保護 · Cloudflare WAF',

  // ── Solutions Page ────────────────────────────────
  sol_breadcrumb_home: '首頁',
  sol_breadcrumb_current: '系統開發',
  sol_badge: '客製化系統開發',
  sol_title1: '客製化系統開發',
  sol_title2: '驅動企業數位轉型',
  sol_desc: '根據您的業務需求量身打造企業管理系統，從需求分析到上線部署，全程提供技術支援，助您提升效率、降低成本、實現智慧化運營。',
  sol_cta1: '免費咨詢',
  sol_cta2: '查看開發案例',
  sol_grid_title: '我們的開發服務',
  sol_grid_sub: '涵蓋企業數位轉型的每個關鍵層面',
  sol_s1_title: '企業資源規劃（ERP）',
  sol_s1_desc: '整合財務、採購、生產、銷售及人事的一體化管理平台，消除數據孤島，提升跨部門協作效率。',
  sol_s1_f1: '多部門數據整合',
  sol_s1_f2: '即時財務報表',
  sol_s1_f3: '自動化工作流程',
  sol_s1_f4: '角色權限管控',
  sol_s2_title: '雲端 SaaS 應用開發',
  sol_s2_desc: '基於 Microsoft Azure / AWS 的雲原生應用開發，確保高可用性、彈性擴展並降低 IT 基礎設施成本。',
  sol_s2_f1: '雲原生架構',
  sol_s2_f2: '自動彈性擴展',
  sol_s2_f3: '99.9% SLA 保障',
  sol_s2_f4: '多雲部署',
  sol_s3_title: '企業移動應用程式',
  sol_s3_desc: '開發 iOS 及 Android 企業移動應用，讓員工隨時隨地管理業務，提升外勤團隊與管理層的靈活性。',
  sol_s3_f1: 'iOS / Android 原生開發',
  sol_s3_f2: '離線模式支援',
  sol_s3_f3: '企業 MDM 整合',
  sol_s3_f4: '推送通知系統',
  sol_s4_title: 'API 整合與第三方系統對接',
  sol_s4_desc: '將現有系統與第三方平台（電商、物流、支付、政府服務）對接，精簡數據流轉，減少人工操作。',
  sol_s4_f1: 'RESTful / GraphQL API',
  sol_s4_f2: 'Webhook 自動化',
  sol_s4_f3: '舊系統現代化改造',
  sol_s4_f4: '數據遷移方案',
  sol_process_title: '開發流程',
  sol_process_sub: '透明可控的項目管理——讓您全程掌握進度',
  sol_p1_step: '01',
  sol_p1_title: '需求分析',
  sol_p1_desc: '深入了解業務流程與痛點，確定功能範圍及技術規格',
  sol_p2_step: '02',
  sol_p2_title: '系統設計',
  sol_p2_desc: '架構設計、數據庫建模、UI/UX 原型確認',
  sol_p3_step: '03',
  sol_p3_title: '迭代開發',
  sol_p3_desc: '敏捷開發模式，定期進行進度演示，快速響應需求變更',
  sol_p4_step: '04',
  sol_p4_title: '測試與上線',
  sol_p4_desc: '全面測試（UAT、壓力測試）後部署上線，並提供員工培訓',
  sol_p5_step: '05',
  sol_p5_title: '維護與支援',
  sol_p5_desc: '長期技術支援、系統更新及持續優化服務',
  sol_cta_title: '準備好開始您的系統開發項目？',
  sol_cta_desc: '聯繫我們的技術顧問，獲取免費需求評估及項目報價',
  sol_cta_btn: '立即獲取報價',

  // ── Infrastructure Page ───────────────────────────
  infra_breadcrumb_home: '首頁',
  infra_breadcrumb_current: '網絡基礎設施',
  infra_badge: '網絡基礎設施',
  infra_title1: '企業級網絡架構',
  infra_title2: '高效、穩定、可擴展',
  infra_desc: '我們為全球企業設計並部署現代化網絡基礎設施，解決跨辦公室連接、網絡穩定性及擴展性問題，讓您的業務不再受網絡瓶頸所制。',
  infra_cta1: '免費網絡評估',
  infra_cta2: '查看網絡案例',
  infra_pain_title: '您是否正面對這些網絡困境？',
  infra_pain_sub: '這些是我們每天為企業解決的常見痛點。',
  infra_pain1: '辦公室網絡頻繁斷線或不穩定',
  infra_pain2: '跨境視像會議延遲嚴重',
  infra_pain3: '多個分支辦公室難以統一管理',
  infra_pain4: '網絡故障影響業務正常運作',
  infra_pain5: '現有網絡無法支撐業務增長',
  infra_pain6: '缺乏網絡可視性與監控能力',
  infra_svc_title: '網絡基礎設施服務',
  infra_svc_sub: '從設計到部署的端對端網絡工程服務',
  infra_s1_title: 'SD-WAN 優化',
  infra_s1_desc: '利用軟件定義廣域網技術，集中管理多辦公室的網絡連接，動態分配頻寬，確保關鍵業務應用優先通行。',
  infra_s1_f1: '多線路負載均衡',
  infra_s1_f2: '智能路徑選擇',
  infra_s1_f3: '集中管理門戶',
  infra_s1_f4: 'QoS 服務品質保障',
  infra_s2_title: '企業無線網絡覆蓋',
  infra_s2_desc: '為辦公室、倉庫及工廠提供高密度無線網絡方案，支援大量設備同時連接，實現全場所穩定覆蓋。',
  infra_s2_f1: 'Wi-Fi 6/6E 部署',
  infra_s2_f2: '訪客網絡隔離',
  infra_s2_f3: '無線入侵偵測',
  infra_s2_f4: '位置感知分析',
  infra_s3_title: '數據中心與伺服器架構',
  infra_s3_desc: '規劃及建設企業級數據中心，涵蓋伺服器虛擬化、存儲架構設計及備份容災方案，全面保障您的數據安全。',
  infra_s3_f1: 'VMware / Hyper-V 虛擬化',
  infra_s3_f2: 'SAN / NAS 存儲',
  infra_s3_f3: '備份與容災恢復',
  infra_s3_f4: '數據中心環境監控',
  infra_s4_title: '局域網設計與實施',
  infra_s4_desc: '為企業辦公環境設計高性能、高可用的內部網絡架構，包括交換機及路由器配置，以及網絡分段規劃。',
  infra_s4_f1: 'VLAN 網絡分段',
  infra_s4_f2: '核心／匯聚／接入三層架構',
  infra_s4_f3: '冗餘鏈路設計',
  infra_s4_f4: '網絡文檔與拓撲圖',
  infra_cta_title: '讓我們評估您現有的網絡架構',
  infra_cta_desc: '我們的工程師將進行全面的現場評估，並提供針對性的網絡優化建議——完全免費，無需承諾。',
  infra_cta_btn: '預約免費評估',

  // ── Security Page ─────────────────────────────────
  sec_breadcrumb_home: '首頁',
  sec_breadcrumb_current: '網絡安全',
  sec_badge: '網絡安全與防火牆',
  sec_title1: '主動防禦，',
  sec_title2: '而非事後補救',
  sec_desc: '我們為您構建多層防禦體系，在駭客入侵前先行保護。從防火牆部署到滲透測試，全面守護您的企業數位資產。',
  sec_cta1: '免費安全評估',
  sec_cta2: '安全案例參考',
  sec_threats_title: '企業當前面臨的主要網絡威脅',
  sec_threats_sub: '全球企業的網絡安全威脅持續升溫，主動防禦刻不容緩',
  sec_t1_name: '勒索軟件',
  sec_t1_stat: '勒索關鍵業務數據',
  sec_t2_name: '網絡釣魚',
  sec_t2_stat: '憑證洩露的首要原因',
  sec_t3_name: 'DDoS 攻擊',
  sec_t3_stat: '癱瘓業務正常運作',
  sec_t4_name: '內部威脅',
  sec_t4_stat: '利用內部訪問權限作惡',
  sec_svc_title: '網絡安全服務',
  sec_svc_sub: '多層防禦策略，全面保護您的企業信息資產',
  sec_s1_title: '新一代防火牆（NGFW）',
  sec_s1_badge: 'Fortinet · Palo Alto · Cisco',
  sec_s1_desc: '部署具備應用識別、入侵防禦（IPS）及 SSL 深度檢測功能的新一代防火牆，有效攔截高級持續威脅（APT）及勒索軟件。',
  sec_s1_f1: '應用層流量管控',
  sec_s1_f2: 'SSL/TLS 深度解密',
  sec_s1_f3: '威脅情報整合',
  sec_s1_f4: '零信任架構支援',
  sec_s2_title: '網頁應用防火牆（WAF）',
  sec_s2_badge: 'Cloudflare · F5 · AWS WAF',
  sec_s2_desc: '保護企業網站及 Web 應用程式免受 SQL 注入、XSS 跨站攻擊及 OWASP Top 10 漏洞威脅，達到 PCI DSS 合規要求。',
  sec_s2_f1: 'OWASP Top 10 防護',
  sec_s2_f2: 'DDoS 緩解',
  sec_s2_f3: 'Bot 機器人管理',
  sec_s2_f4: 'API 安全防護',
  sec_s3_title: '入侵偵測與防禦（IDS/IPS）',
  sec_s3_badge: 'Snort · Suricata · Splunk',
  sec_s3_desc: '24/7 全天候監控網絡流量，即時偵測異常行為及入侵嘗試，自動觸發攔截機制並生成安全事件報告。',
  sec_s3_f1: '行為異常偵測',
  sec_s3_f2: '自動化威脅響應',
  sec_s3_f3: 'SIEM 日誌整合',
  sec_s3_f4: '合規審計報告',
  sec_s4_title: '滲透測試與安全評估',
  sec_s4_badge: 'CREST · OWASP Standards',
  sec_s4_desc: '模擬駭客攻擊手法，對企業系統進行全面滲透測試，識別安全漏洞並提供修復建議。',
  sec_s4_f1: '黑盒／白盒測試',
  sec_s4_f2: '社會工程測試',
  sec_s4_f3: '漏洞掃描報告',
  sec_s4_f4: '修復建議清單',
  sec_compliance_title: '合規支援',
  sec_compliance_desc: '我們協助企業滿足 GDPR、PCI DSS、ISO 27001 等國際及地區性數據保護法規的網絡安全合規要求，避免罰款及聲譽損失。',
  sec_cta_title: '立即發現您的企業安全漏洞',
  sec_cta_desc: '我們的安全專家將提供免費企業網絡安全風險評估，識別潛在威脅',
  sec_cta_btn: '預約免費安全評估',

  // ── Case Studies Page ─────────────────────────────
  cs_badge: '成功案例',
  cs_hero_title1: '真實企業 IT 轉型',
  cs_hero_title2: '成功案例',
  cs_hero_desc: '從網絡安全到系統開發，我們為各行各業的企業解決真實的 IT 挑戰——每一個案例都是客戶對我們信任的最好見證',
  cs_stat1_label: '完成項目',
  cs_stat2_label: '服務行業',
  cs_stat3_label: '客戶滿意度',
  cs_filter_all: '全部',
  cs_filter_retail: '零售業',
  cs_filter_finance: '金融業',
  cs_filter_healthcare: '醫療業',
  cs_label_challenge: '挑戰',
  cs_label_solution: '解決方案',
  cs_c1_industry: '零售業',
  cs_c1_company: '大型連鎖零售集團',
  cs_c1_challenge: '集團旗下 50+ 間分店各自獨立組網，IT 管理複雜，跨店數據同步緩慢，POS 系統在運營期間頻繁斷線。',
  cs_c1_solution: '設計並部署基於 Fortinet SD-WAN 的統一廣域網絡，集中管理所有分店，並升級 POS 至總部 ERP 的整合接口。',
  cs_c1_r1_metric: '99.8%',
  cs_c1_r1_label: '網絡正常運行率',
  cs_c1_r2_metric: '60%',
  cs_c1_r2_label: '營運成本節省',
  cs_c1_r3_metric: '50+',
  cs_c1_r3_label: '覆蓋門店數',
  cs_c1_t1: 'SD-WAN',
  cs_c1_t2: '網絡基礎設施',
  cs_c1_t3: 'ERP 整合',
  cs_c2_industry: '金融業',
  cs_c2_company: '持牌金融公司',
  cs_c2_challenge: '公司存儲大量客戶財務數據，需要符合國際金融法規合規要求，同時應對日益增多的針對性網絡攻擊。',
  cs_c2_solution: '部署 Palo Alto NGFW 及 WAF 建立多層防禦架構，設置精細訪問控制策略，並通過第三方滲透測試驗證。',
  cs_c2_r1_metric: '100%',
  cs_c2_r1_label: '合規達標',
  cs_c2_r2_metric: '0',
  cs_c2_r2_label: '安全事故',
  cs_c2_r3_metric: '3倍',
  cs_c2_r3_label: '攔截攻擊次數',
  cs_c2_t1: 'NGFW 防火牆',
  cs_c2_t2: 'WAF',
  cs_c2_t3: '合規審計',
  cs_c3_industry: '醫療業',
  cs_c3_company: '私家診所連鎖集團',
  cs_c3_challenge: '病人病歷分散各診所，預約系統過時，醫生無法查閱跨診所病歷，且需符合數據私隱合規要求。',
  cs_c3_solution: '開發統一診所管理系統，整合預約、病歷、藥物管理及收費功能，並配備符合 GDPR 標準的數據加密及訪問控制。',
  cs_c3_r1_metric: '70%',
  cs_c3_r1_label: '預約效率提升',
  cs_c3_r2_metric: 'GDPR',
  cs_c3_r2_label: '合規通過',
  cs_c3_r3_metric: '8',
  cs_c3_r3_label: '整合診所數',
  cs_c3_t1: '醫療管理系統',
  cs_c3_t2: '私隱合規',
  cs_c3_t3: '數據安全',
  cs_cta_title: '您的業務將成為我們下一個成功案例',
  cs_cta_desc: '無論是系統開發、網絡基礎設施還是網絡安全——立即聯繫我們的技術顧問，獲取免費評估',
  cs_cta_btn: '免費技術評估',

  // ── About Page ────────────────────────────────────
  about_badge: '關於我們',
  about_hero_title1: '全球企業 IT 服務',
  about_hero_title2: '您信賴的技術合作夥伴',
  about_hero_desc: 'A&B System 為全球企業提供服務逾 15 年，由一群資深 IT 專業人員組成，專注於系統開發、網絡基礎設施及網絡安全解決方案，服務覆蓋國際市場。',
  about_stat1_num: '15+',
  about_stat1_label: '年業界經驗',
  about_stat2_num: '200+',
  about_stat2_label: '完成項目',
  about_stat3_num: '24/7',
  about_stat3_label: '全天候技術支援',
  about_mission_badge: '我們的使命',
  about_mission_title1: '每個企業都值得擁有',
  about_mission_title2: '企業級 IT 保護',
  about_mission_desc1: 'A&B System 相信，世界級的 IT 基礎設施與網絡安全不應只屬於大企業。我們的使命是以合理的成本，為全球各規模企業提供企業級技術解決方案。',
  about_mission_desc2: '我們不只是技術服務供應商——更是您的長期策略 IT 夥伴。從初次咨詢到部署後的持續支援，我們全程陪伴您。',
  about_mission_i1_title: '以業務為先',
  about_mission_i1_desc: '在提出方案前，我們深入了解您的業務需求——絕不推銷千篇一律的標準方案',
  about_mission_i2_title: '完全透明',
  about_mission_i2_desc: '清晰的項目時間線、費用明細及技術說明——絕無隱藏收費',
  about_mission_i3_title: '長期夥伴關係',
  about_mission_i3_desc: '項目完成後持續提供支援——與您的業務共同成長',
  about_mission_uptime_label: '系統平均正常運行率',
  about_team_badge: '技術團隊',
  about_team_title: '認識我們的專家團隊',
  about_team_desc: '每位成員均持有多項國際認證，為全球企業帶來豐富的實戰經驗',
  about_tm1_role: '創辦人及技術總監',
  about_tm1_bio: '前 Cisco 認證工程師，擁有 20 年企業網絡架構經驗',
  about_tm2_role: '信息安全主管',
  about_tm2_bio: 'CISSP 認證專業人員，在金融業安全項目方面擁有豐富經驗',
  about_tm3_role: '系統開發總監',
  about_tm3_bio: '雲端架構專家，曾主導逾 50 個企業系統開發項目',
  about_tm4_role: '項目管理主任',
  about_tm4_bio: 'PMP 認證項目經理，確保每個項目準時交付並超越客戶期望',
  about_values_badge: '核心價值',
  about_values_title: '我們堅守的原則',
  about_values_desc: '這些價值觀指導我們每一個決策，塑造我們與客戶合作的方式',
  about_v1_title: '安全優先',
  about_v1_desc: '信息安全是每個項目的核心原則，不可妥協。我們以最高標準保護客戶的數位資產。',
  about_v2_title: '卓越技術',
  about_v2_desc: '我們持續提升技術能力，持有多項國際認證，確保服務達到業界最高標準。',
  about_v3_title: '透明誠信',
  about_v3_desc: '清晰的項目進度、費用說明及定期匯報，與每位客戶建立持久的信任關係。',
  about_v4_title: '以客為本',
  about_v4_desc: '我們花時間深入了解每位客戶的業務需求，提供針對性方案，而非千篇一律的套餐。',
  about_v5_title: '快速響應',
  about_v5_desc: '承諾 30 分鐘緊急響應時間，確保您的業務不因 IT 問題而中斷。',
  about_v6_title: '持續支援',
  about_v6_desc: '項目交付後持續提供技術支援及系統優化——我們是您的長期 IT 夥伴。',
  about_why_badge: '為何選擇我們',
  about_why_title: 'A&B System 六大優勢',
  about_why_desc: '不只是 IT 服務供應商——您最可靠的長期技術夥伴',
  about_r1_num: '01',
  about_r1_title: '深厚技術認證',
  about_r1_desc: '核心技術團隊持有國際認可認證，包括 Cisco CCNP、Fortinet NSE 及 Palo Alto PCNSE。',
  about_r2_num: '02',
  about_r2_title: '量身定制方案',
  about_r2_desc: '絕不套用固定模板。我們深入分析您的業務流程，設計最適合的 IT 方案，最大化投資回報。',
  about_r3_num: '03',
  about_r3_title: '全透明項目管理',
  about_r3_desc: '定期進度報告清晰列明交付成果。客戶全程知情——無隱藏費用，無意外驚喜。',
  about_r4_num: '04',
  about_r4_title: '24/7 緊急響應',
  about_r4_desc: '全年緊急技術支援，平均響應時間少於 30 分鐘，確保您的業務不間斷運行。',
  about_r5_num: '05',
  about_r5_title: '多行業專業知識',
  about_r5_desc: '服務零售、金融、製造、醫療等行業，深入掌握各行業合規要求及 IT 痛點。',
  about_r6_num: '06',
  about_r6_title: '長期夥伴關係',
  about_r6_desc: '許多客戶與我們合作多年，持續的信任正是我們服務品質、可靠性及一致性的最好佐證。',
  about_why_cta: '免費咨詢',

  // ── Contact Page ──────────────────────────────────
  contact_badge: '聯絡我們',
  contact_hero_title1: '開始您的',
  contact_hero_title2: 'IT 轉型之旅',
  contact_hero_desc: '透過以下表格、WhatsApp 或電話聯繫我們。我們的技術顧問將在 24 小時內回覆您的查詢。',
  contact_badge1_label: '24 小時內回覆',
  contact_badge1_sub: '週一至週五  9:00–18:00',
  contact_badge2_label: '免費諮詢',
  contact_badge2_sub: '絕無隱藏收費',
  contact_badge3_label: '保密協議保障',
  contact_badge3_sub: '您的資料受到完全保護',
  contact_form_title: '發送查詢',
  contact_form_desc: '填寫以下表格，我們的技術顧問將盡快回覆您',
  contact_field_name: '聯絡人姓名',
  contact_field_company: '公司名稱',
  contact_field_email: '電郵地址',
  contact_field_message: '描述您的需求',
  contact_placeholder_name: '王大明',
  contact_placeholder_company: 'ABC 有限公司',
  contact_placeholder_email: 'info@company.com',
  contact_placeholder_message: '簡述您的業務需求或 IT 挑戰，最多 500 字。',
  contact_submit: '提交查詢',
  contact_submitting: '提交中...',
  contact_success_title: '查詢已成功提交！',
  contact_success_desc: '我們將在 24 小時內回覆您，感謝您的聯繫。',
  contact_error_title: '提交失敗，請重試',
  contact_error_desc: '或直接透過 WhatsApp 聯繫我們：+852 2000 0000',
  contact_info_title: '聯絡資料',
  contact_info_desc: '我們的技術顧問隨時準備解答您的 IT 問題，選擇最方便的聯繫方式。',
  contact_email_label: '電郵',
  contact_email_sub: '工作日 24 小時內回覆',
  contact_emergency_title: '24/7 緊急支援',
  contact_emergency_desc: '遇到緊急 IT 事故——伺服器當機、網絡中斷或安全漏洞——請致電我們的緊急熱線，保證 30 分鐘內響應。',
  contact_partners_label: '授權合作夥伴',
};

export default zhTW;
